import axios from "axios";
import { AppDispatch } from "../Store";
import { applicationSlice } from "../reducers/ApplicationSlice";
import { GET_APPLICATION_API } from "./endpoints";
import {
  IApplication,
  IGetApplicationPayload,
} from "../types/ApplicationTypes";

interface IGetApplicationsResponse {
  data: IApplication[];
}

export const getApplicationInfo =
  (payload: IGetApplicationPayload) => async (dispatch: AppDispatch) => {
    const id = payload.id?.trim();
    const orderId = payload.order_id?.trim();
    const vehicleNumber = payload.vehicle_number?.trim();
    const vin = payload.vin?.trim();

    if (!id && !orderId && !vehicleNumber && !vin) {
      dispatch(
        applicationSlice.actions.applicationFailed(
          "Введите номер заявки, номер инвойса, номер VIN-кода или номер автомобиля",
        ),
      );
      return;
    }

    try {
      dispatch(applicationSlice.actions.applicationLoading());

      const body: IGetApplicationPayload = id
        ? { id }
        : orderId
          ? { order_id: orderId }
          : vin
            ? { vin }
            : { vehicle_number: vehicleNumber };

      const res = await axios.post<IGetApplicationsResponse>(
        GET_APPLICATION_API,
        body,
        {
          withCredentials: true,
        },
      );

      dispatch(applicationSlice.actions.applicationSuccess(res.data.data));
    } catch (error: unknown) {
      const message = axios.isAxiosError<{ message?: string }>(error)
        ? error.response?.data?.message ||
          error.message ||
          "Ошибка при получении данных"
        : "Ошибка при получении данных";

      dispatch(applicationSlice.actions.applicationFailed(message));
    }
  };
